import { FC, useEffect, useState } from "react"
import { CourseContent, chapterDifficulty } from "interfaces/courses"
import { NextSeo } from "next-seo"
import RelatedCourses from "../related-courses/RelatedCourses"
import CourseHeader from "./header/CourseHeader"
import CourseMain from "./main/CourseMain"
import { useRouter } from "next/router"
import { populateStore } from "util/populatei18nStore"

const CourseScreen: FC<CourseContent> = course => {
  const [render, setRender] = useState(false)
  const router = useRouter()

  const { chaptersData, relatedCourses, id } = course

  const difficulty = (router.query.difficulty ?? "advanced") as chapterDifficulty
  const propsToHeader = { ...course, difficulty, chaptersData }
  const propsToMain = { ...course, chaptersData, id, difficulty }
  const propsToRelatedCourses = relatedCourses

  useEffect(() => {
    (async () => {
      setRender(false)
      Promise.all([
        populateStore(router.locale as string, "courses", "en"),
        populateStore(router.locale as string, "footer", "en")
      ]).then(() => {
        setRender(true)
      })
    })()
  }, [router])

  if ( !render ) return  null

  return (
    <>
      <NextSeo title={course.title} />
      <CourseHeader {...propsToHeader} />
      <CourseMain {...propsToMain} />
      <RelatedCourses courses={propsToRelatedCourses} />
    </>
  )
}

export default CourseScreen
